/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersinviteqr2Inputs */

const en_membersinviteqr2 = /** @type {(inputs: Membersinviteqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show QR code`)
};

const de_membersinviteqr2 = /** @type {(inputs: Membersinviteqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code zeigen`)
};

/**
* | output |
* | --- |
* | "Show QR code" |
*
* @param {Membersinviteqr2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersinviteqr2 = /** @type {((inputs?: Membersinviteqr2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersinviteqr2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersinviteqr2(inputs)
	return de_membersinviteqr2(inputs)
});
export { membersinviteqr2 as "membersInviteQr" }